import { atom } from "nanostores";

export const $isEmployeeOrg = atom<boolean>(false);

export const isEmployeeOrgStore = {
  setIsEmployeeOrg: (isEmployee: boolean) => {
    $isEmployeeOrg.set(isEmployee);
  },
};
